import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BrainCircuit, CheckCircle2, Circle, X } from "lucide-react";
import { api } from "../../lib/api";
import { askMariUrl } from "../../lib/onboarding";

const KEY = "aegis-coach-dismissed";

export const PilotCoach = () => {
  const [d, setD] = useState(null);
  const [hidden, setHidden] = useState(() => sessionStorage.getItem(KEY) === "1");
  const nav = useNavigate();
  useEffect(() => { api.get("/pilot/me").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d?.is_pilot || hidden) return null;
  const t = d.training;
  const close = () => { sessionStorage.setItem(KEY, "1"); setHidden(true); api.post("/track", { event: "coach_dismissed", page: window.location.pathname }).catch(() => {}); };
  const ask = () => { api.post("/track", { event: "coach_ask_mari", page: window.location.pathname, meta: { step: t.next?.id } }).catch(() => {}); nav(askMariUrl(t.next ? `Walk me through "${t.next.title}" step by step.` : "Summarize my pilot results so far.")); };
  return (
    <section className="panel mb-6 p-5 relative rise" data-testid="pilot-coach">
      <button onClick={close} className="absolute top-3 right-3 text-white/35 hover:text-white" data-testid="pilot-coach-close"><X className="w-4 h-4" /></button>
      <div className="flex flex-wrap items-start gap-6">
        <div className="max-w-md">
          <p className="label-xs text-brand flex items-center gap-2"><BrainCircuit className="w-3.5 h-3.5" /> MARI · your pilot guide</p>
          <p className="text-xl font-bold mt-2" data-testid="pilot-coach-greeting">Welcome back, {d.first_name}.</p>
          <p className="text-sm text-white/65 mt-1" data-testid="pilot-coach-next">
            {t.next ? <>Pilot training {t.completed}/{t.total}. Next up: <b className="text-white">{t.next.title}</b>. {t.next.how}</> : "Training complete. Your setup is live. I'll flag anything that needs you."}
          </p>
          <div className="flex flex-wrap gap-2 mt-3">
            {t.next && <Link to={t.next.link} className="px-3 py-2 bg-brand text-black font-mono text-[10px] tracking-wider font-bold" data-testid="pilot-coach-go">GO TO STEP →</Link>}
            <button onClick={ask} className="px-3 py-2 border border-brand text-brand font-mono text-[10px] tracking-wider" data-testid="pilot-coach-ask">ASK MARI TO WALK ME THROUGH IT</button>
          </div>
        </div>
        <ol className="grid sm:grid-cols-2 gap-x-6 gap-y-1.5 text-sm flex-1 min-w-[260px]" data-testid="pilot-coach-steps">
          {t.steps.map((s, i) => (
            <li key={s.id} className={`flex items-center gap-2 ${s.done ? "text-white/45 line-through" : s.id === t.next?.id ? "text-white" : "text-white/60"}`} data-testid={`pilot-step-${s.id}`}>
              {s.done ? <CheckCircle2 className="w-4 h-4 text-brand shrink-0" /> : <Circle className="w-4 h-4 shrink-0" />}{i + 1}. {s.title}
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};
